// NewWorkflowDialog — Type-chooser för nytt workflow.
//
// User väljer en av tre profiler innan canvas:n rensas:
//   - standard: vanligt flöde
//   - coop: pre-flag för co-op (delning aktiveras efter första save)
//   - process: pre-flag för process-motor (Enterprise-only run-historik)
//
// Profilen påverkar bara post-create-toast:en och hint-meddelanden i
// SaveDialog — själva data-strukturen är samma. Riktig coop-aktivering
// sker när user klickar "Dela arbetsyta"; process-aktivering kräver
// Enterprise-tier och sker när user klickar "Process"-knappen.
//
// Wave E.2 step 1: body lyftad till workspace-picker/NewWorkflowSection
// så samma UI kan embeddas i den blivande WorkspacePickerDialog som
// en av tre tabs. Denna fil är nu en tunn Dialog-fasad — call-sites
// behöver inte ändras.

import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '@/components/ui/dialog';
import { Sparkles } from 'lucide-react';
import { NewWorkflowSection, type WorkflowKind } from './workspace-picker/NewWorkflowSection';

export type { WorkflowKind };

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Triggar canvas-rens + setCurrentDocumentId(null). */
  onConfirm: (kind: WorkflowKind) => void;
  /** Sant om user är på Enterprise-tier (visar process-motor som tillgängligt). */
  canRunProcesses: boolean;
  /** Sant om user:s plan tillåter co-op (Advanced+). */
  canUseCoop: boolean;
}

export function NewWorkflowDialog({ open, onOpenChange, onConfirm, canRunProcesses, canUseCoop }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="new-workflow-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-primary" />
            Skapa nytt flöde
          </DialogTitle>
          <DialogDescription>
            Välj typ av flöde — det påverkar vilka funktioner som rekommenderas.
            Du kan alltid byta typ senare.
          </DialogDescription>
        </DialogHeader>

        <NewWorkflowSection
          onConfirm={onConfirm}
          onCancel={() => onOpenChange(false)}
          canRunProcesses={canRunProcesses}
          canUseCoop={canUseCoop}
          footerSlot={(content) => <DialogFooter>{content}</DialogFooter>}
        />
      </DialogContent>
    </Dialog>
  );
}
